import React from "react"

const Inventory = () => {
	return (
		<div>
			<h2>this is inventory page</h2>
		</div>
	)
}

export default Inventory
